import { Layout } from "@/layouts/AdminLayout";
import DashboardPage from "@/pages/dashboard/dashboard-page";
import EditorDemoPage from "@/pages/editor-demo-page";
import LoginPage from "@/pages/login-page";
import ManageUserPage from "@/pages/user-management/manage-user";
import ManageUserDetailPage from "@/pages/user-management/manage-user-detail";
import ManageUserProjectListPage from "@/pages/user-management/manage-user-project-list";
import ManageUserAgentListPage from "@/pages/user-management/manage-user-agent-list";
import ManageUserInquiryListPage from "@/pages/user-management/manage-user-inquiry-list";
import SettingsPage from "@/pages/settings-page";
import UsersPage from "@/pages/users-page";
import { Navigate, RouterProvider, createBrowserRouter, useNavigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import ManageAgentListPage from "./pages/manage-agent/manage-agent-list";
import ManageAgentDetailPage from "./pages/manage-agent/manage-agent-detail";
import AddAgentPage from "./pages/manage-agent/add-agent";
import { EditAgentPage } from "./pages/manage-agent/edit-agent";
import AgentHistoryPage from "./pages/manage-agent/agent-history";
import { ProtectedRoute } from "@/components/common/protected-route";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import InquiryDetailPage from "./pages/manage-inquiry/manage-inquiry-detail";
import ManageInquiryListPage from "./pages/manage-inquiry/manage-inquiry-list";
import AdminManagementListPage from "./pages/admin-management/admin-management-list-page";
import AdminDetailPage from "./pages/admin-management/Admin-detail";
import ProjectReportListPage from "./pages/project-report/project-report-list-page";
import ProjectReportDetailPage from "./pages/project-report/project-report-detail-page";
import AxNewsListPage from "./pages/ax-news/ax-news-list-page";
import AxNewsForm from "./pages/ax-news/ax-news-form";
import AxNewsDetailPage from "./pages/ax-news/ax-news-detail";
import { NotFoundPage } from "./pages/error/not-found-page";
import { RouterErrorElement } from "./pages/error/router-error-element";
import { ServerErrorRoute } from "./pages/error/server-error-route";

function GlobalNavigationListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleServerError = (event: any) => {
      const status = event.detail?.status || 500;
      navigate(`/server-error?status=${status}`, { replace: true });
    };

    const handleNotFound = () => {
      navigate("/404", { replace: true });
    };

    window.addEventListener("server:error", handleServerError);
    window.addEventListener("server:not-found", handleNotFound);

    return () => {
      window.removeEventListener("server:error", handleServerError);
      window.removeEventListener("server:not-found", handleNotFound);
    };
  }, [navigate]);

  return null;
}

const routes: any[] = [
  {
    element: (
      <>
        <GlobalNavigationListener />
        <Outlet />
      </>
    ),
    children: [
    { path: "/login", element: <LoginPage /> },
    { path: "/editor-demo", element: <EditorDemoPage /> },
    { path: "/404", element: <NotFoundPage /> },
    { path: "/server-error", element: <ServerErrorRoute /> },
    { path: "*", element: <NotFoundPage /> },
    {
      element: <ProtectedRoute />,
      children: [
        {
          element: <Layout />,
          children: [
            { index: true, element: <Navigate to="/dashboard" replace /> },
            { path: "/dashboard", handle: { title: "대시보드" }, element: <DashboardPage /> },
            {
              path: "/agents",
              handle: { title: "에이전트 관리" },
              element: <ManageAgentListPage />,
            },
            {
              path: "/agents/:id",
              handle: { title: "에이전트 상세" },
              element: <ManageAgentDetailPage />,
            },
            {
              path: "/agents/add-agent",
              handle: { title: "에이전트 등록" },
              element: <AddAgentPage />,
            },
            {
              path: "/agents/:id/edit",
              handle: { title: "에이전트 수정" },
              element: <EditAgentPage />,
            },
            {
              path: "/agents/:id/history",
              handle: { title: "에이전트 수정 이력" },
              element: <AgentHistoryPage />,
            },

            { path: "/users", handle: { title: "Users" }, element: <UsersPage /> },
            { path: "/settings", handle: { title: "Settings" }, element: <SettingsPage /> },
            {
              path: "/inquiries",
              handle: { title: "문의 관리" },
              element: <ManageInquiryListPage />,
            },
            {
              path: "/inquiries/:id",
              handle: { title: "문의 상세" },
              element: <InquiryDetailPage />,
            },
            { path: "/manage-user", handle: { title: "사용자 관리" }, element: <ManageUserPage /> },
            {
              path: "/manage-user/:id",
              handle: { title: "사용자 관리" },
              element: <ManageUserDetailPage />,
            },
            {
              path: "/manage-user/:id/agent-list",
              handle: { title: "사용자 관리" },
              element: <ManageUserAgentListPage />,
            },
            {
              path: "/manage-user/:id/project-list",
              handle: { title: "사용자 관리" },
              element: <ManageUserProjectListPage />,
            },
            {
              path: "/manage-user/:id/inquiry-list",
              handle: { title: "사용자 관리 " },
              element: <ManageUserInquiryListPage />,
            },
            {
              path: "/manage-user/:id/list",
              handle: { title: "사용자 관리" },
              element: <ManageUserAgentListPage />,
            },
            {
              path: "/admin-management",
              handle: { title: "관리자 관리 " },
              element: <AdminManagementListPage />,
            },
            {
              path: "/admin-management/create",
              handle: { title: "관리자 등록" },
              element: <AdminDetailPage />,
            },
            {
              path: "/admin-management/:id",
              handle: { title: "관리자 등록" },
              element: <AdminDetailPage />,
            },
            {
              path: "/admin-management/:id/edit",
              handle: { title: "관리자 등록" },
              element: <AdminDetailPage />,
            },
            {
              path: "/projects",
              handle: { title: "프로젝트 관리" },
              element: <ProjectReportListPage />,
            },
            {
              path: "/projects/:id",
              handle: { title: "프로젝트 상세" },
              element: <ProjectReportDetailPage />,
            },
            {
              path: "/ax-trend-hub",
              handle: { title: "AX Trend Hub" },
              element: <AxNewsListPage />,
            },
            {
              path: "/ax-trend-hub/create",
              handle: { title: "AX Trend Hub" },
              element: <AxNewsForm />,
            },
            {
              path: "/ax-trend-hub/:id",
              handle: { title: "AX Trend Hub 상세" },
              element: <AxNewsDetailPage />,
            },
            {
              path: "/ax-trend-hub/:id/edit",
              handle: { title: "대시보드" },
              element: <AxNewsForm />,
            },
          ],
        },
      ],
    },
  ],
  },
];

routes.forEach((route) => {
  route.errorElement = <RouterErrorElement />;
});

const router = createBrowserRouter(routes, { basename: "/admin" });

export default function App() {
  return (
    <TooltipProvider>
      <RouterProvider router={router} />
      <Toaster />
    </TooltipProvider>
  );
}
